import { Controller, useFormContext } from "react-hook-form";

import Box from "ds/components/Box";
import FormToggleField from "ds/components/Form/ToggleField";

type GitCheckoutToggleProps = {
  disabled?: boolean;
};

const GitCheckoutToggle = ({ disabled }: GitCheckoutToggleProps) => {
  const { control } = useFormContext();

  return (
    <Box padding="large 0 0">
      <Controller
        name="useGitCheckout"
        control={control}
        render={({ field }) => (
          <FormToggleField
            variant="switch"
            onChange={field.onChange}
            checked={field.value}
            title="Use Git checkout"
            description="Enable this option to use Git checkout for this integration. This is required for sparse checkout."
            disabled={disabled}
            tooltipInfo={
              disabled ? "For this provider Git checkout is always turned on" : undefined
            }
            tooltipInfoVariant="standard"
          />
        )}
      />
    </Box>
  );
};

export default GitCheckoutToggle;
